import * as React from "react";
// 登录模板
// import LoginWSTmp from "./login_ws_tmp";
// // 异常模板
// import AbnormalWSTmp from "./abnormal-ws-tmp";
// // 订单更新模板
// import OrderUpdWSTmp from "./orderUpd-ws-tmp";
// // 群组消息模板
// import GroupWSTmp from "./group-ws-tmp";
// 客服消息模板
// import NCSWSTmp from "./ncs-ws-tmp";
import renderList from "./renderList";

// 无限滚动样式
import InfiniteScroll from "react-infinite-scroller";
import { PositionProperty } from "csstype";
// import "react-virtualized/styles.css";

// import List from "react-virtualized/dist/commonjs/List";
// import InfiniteLoader from "react-virtualized/dist/commonjs/InfiniteLoader";

// 消息枚举
//import { ENoticeLevel, EUnreadStatus, ECollectStatus } from "utils/enum/notice";

// 消息列表

interface INoticeListProps {
  // 获取消息列表
  getNoticeList: any;
  // 标记为已读
  tagRead: any;
  // 标记为收藏
  tagCollect: any;
  // 消息列表
  noticeList: any;
  // 清除该组件中的所有的状态 true: 清除
  isClearAllState?: any;
  setRef?: any;
  // 是否需要滚动
  hasMore?: any;
  style?: any;
}

class NoticeList extends React.Component<INoticeListProps, any> {
  constructor(props: INoticeListProps) {
    super(props);
    this.props.setRef && this.props.setRef(this);
    // this.
  }

  renderInfiniteList = ({ onRowsRendered, registerChild }) => {
    return (
      <div />
      // <List
      //   ref={registerChild}
      //   onRowsRendered={onRowsRendered}
      //   rowRenderer={renderList(this.props.noticeList)}
      // />
    );
  };

  noticeList = null;
  getNoticeListRef = ref => {
    this.noticeList = ref;
  };

  // 设置滚动组件的父组件引用
  setInfiniteScrollParent = () => {
    return this.noticeList;
  };

  loaderLoading = () => {
    let text = "";
    if (this.props.noticeList.length === 0) {
      text = "暂无数据";
    } else {
      text = " Loading ...";
    }
    return (
      <div className="loader" key={-1}>
        {text}
      </div>
    );
  };

  btnStyle = {
    position: "absolute" as PositionProperty,
    top: 0,
    left: 0
  };

  // 滚动到顶部
  returnToTop = () => {
    const dom = document.querySelector(".notice-list");
    if (dom) {
      dom["scrollTop"] = 0;
      console.log("scrollTop", dom["scrollTop"]);
    }
  };

  renderList = () => {
    let emptyContent: any;
    if (this.props.noticeList.length === 0) {
      emptyContent = (
        <div className="loader" key={-1}>
          {"暂无数据"}
        </div>
      );
    } else {
      emptyContent = [];
    }

    // 清除所有状态，滚动条回到顶部
    if (this.props.isClearAllState) {
      return [emptyContent, renderList(this.props)];
    } else if (this.props.hasMore) {
      return (
        <InfiniteScroll
          initialLoad={false}
          pageStart={1}
          // isReverse={true}
          loadMore={this.props.getNoticeList}
          hasMore={this.props.hasMore}
          useWindow={false}
          getScrollParent={this.setInfiniteScrollParent}
          loader={this.loaderLoading()}
          //   <div className="loader" key={0}>
          //     Loading ...
          //   </div>
          // }
        >
          {renderList(this.props)}
        </InfiniteScroll>
      );
    } else {
      return [emptyContent, renderList(this.props)];
    }
  };

  render() {
    console.log("this.props.noticeList", this.props.noticeList);
    // const data = [
    //   { type: 1 },
    //   { type: 2 },
    //   { type: 3 },
    //   { type: 4 },
    //   { type: 5 }
    // ];
    {
      /* <InfiniteLoader
          isRowLoaded={true}
          loadMoreRows={this.props.getNoticeList}
          rowCount={5}
        /> */
    }
    if (this.props.isClearAllState) {
      this.returnToTop();
    }
    return (
      <div className="notice-list" style={this.props.style || {}}>
        {this.renderList()}
      </div>
    );
  }
}

{
  /* <button style={this.btnStyle} onClick={this.returnToTop}>
测试滚动到顶部的功能
</button> */
}

{
  /* <LoginWSTmp isUnread={EUnreadStatus.No} />
        <LoginWSTmp
          isNoticeLevel={ENoticeLevel.Importance}
          isUnread={EUnreadStatus.Yes}
          isUnCollect={ECollectStatus.Yes}
          noticeNum={10000000000}
        />
        <AbnormalWSTmp />
        <AbnormalWSTmp
          isNoticeLevel={ENoticeLevel.Importance}
          isUnread={EUnreadStatus.Yes}
          isUnCollect={ECollectStatus.Yes}
        />
        <OrderUpdWSTmp />
        <GroupWSTmp /> */
}
{
  /* <NCSWSTmp /> */
}
export default NoticeList;
